/**
 * Countdown bar (sections/announcement-countdown.liquid)
 * Liquid renders the first frame; this keeps the digits ticking and handles expiry.
 */
if (!customElements.get('announcement-countdown')) {
  customElements.define(
    'announcement-countdown',
    class AnnouncementCountdown extends HTMLElement {
      connectedCallback() {
        const { endDate, endTime = '23:59', timezoneOffset = '' } = this.dataset;
        const [hours = '23', minutes = '59'] = endTime.split(':');
        const time = `${hours.trim().padStart(2, '0')}:${minutes.trim().padStart(2, '0')}:00`;

        this.target = Date.parse(`${endDate}T${time}${timezoneOffset}`);
        if (Number.isNaN(this.target)) return;

        this.values = {};
        this.querySelectorAll('[data-unit]').forEach((el) => {
          this.values[el.dataset.unit] = el;
        });

        this.tick();
        this.interval = setInterval(() => this.tick(), 1000);
      }

      disconnectedCallback() {
        clearInterval(this.interval);
      }

      tick() {
        const remaining = Math.max(0, Math.floor((this.target - Date.now()) / 1000));

        this.render({
          days: Math.floor(remaining / 86400),
          hours: Math.floor((remaining % 86400) / 3600),
          minutes: Math.floor((remaining % 3600) / 60),
          seconds: remaining % 60,
        });

        if (remaining > 0) return;

        clearInterval(this.interval);
        // Keep the bar visible in the theme editor so it can still be edited
        if (this.dataset.expireAction === 'hide' && !window.Shopify?.designMode) {
          this.hidden = true;
        }
      }

      render(units) {
        Object.entries(units).forEach(([unit, value]) => {
          const el = this.values[unit];
          if (!el) return;
          const text = String(value).padStart(2, '0');
          if (el.textContent !== text) el.textContent = text;
        });
      }
    }
  );
}
